/**
 * Owner: Masa Bayu
 * File: session-auth.ts
 * Date:Time: 2026-10-22 10:22
 * Description: §457 F4 — gerbang sesi qxread. Strict: token + akaun, tiada
 *   tetamu demo. Sumber token ialah stor sesi hub (`qxread.hub.token.v1`);
 *   stor identiti projek luar sudah dimatikan sepenuhnya.
 */

import { getHubAuthToken } from '../publication/hub-auth';
import type { AuthSessionView } from './session-types';

/** True hanya dengan token hub dan muatan akaun dalam pandangan sesi. */
export function isHubSignedIn(session: AuthSessionView | null | undefined): boolean {
  if (!session?.account?.user?.id) return false;
  if (!session.account.profile?.displayName && !session.account.user.email) return false;
  const token = (session.token ?? getHubAuthToken())?.trim();
  return Boolean(token);
}

/** §414 — aturan ikon profil: sesi nyata → profil reader; tetamu → login dengan returnTo. */
export function accountEntryPath(signedIn: boolean): string {
  return signedIn ? '/account' : '/login?returnTo=%2Faccount';
}

/**
 * §468 — akaun pentadbir QX ialah identiti rasmi, bukan pembaca. Keputusan ini
 * dibaca daripada `roles` projekti hub (`['admin']`), bukan diteka daripada
 * e-mel atau nama; laluan /admin tetap disahkan pelayan (`AdminAccessGate`).
 */
export function isHubAdmin(session: AuthSessionView | null | undefined): boolean {
  return (session?.account?.roles ?? []).includes('admin');
}
